export default __webpack_public_path__ + "static/media/image4.1a3e630c.png";